/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2022-09-15 11:26:10
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-08-17 13:24:57
 */
import type { App } from 'vue'
import 'ant-design-vue/dist/antd.less'
import '@xinghai/site-common/dist/es/index.css'
const plugins: any[] = []

export default function registerPlugin(app: App) {
  plugins.forEach((p) => app.use(p))
}
